import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

@Component({
  selector: 'background-modal',
  templateUrl: './background-modal.component.html',
  styleUrls: ['./background-modal.component.scss'],
  standalone: true,
  imports: [MatProgressSpinnerModule, CommonModule]
})
export class BackgroundmodalComponent implements OnInit {
  constructor() { }

  @Input() isLoading: boolean = false;

  ngOnInit(): void {
  }

}
